module.exports = __webpack_public_path__ + "static/img/altiumSymbolManage.2419328b.png";